<div
  data-id="bd-page-not-found"
  *transloco="let t; scope: 'uiComponents'; prefix: 'uiComponents'"
>
  <div
    class="flex absolute inset-0 h-screen w-screen justify-center items-center"
  >
    <bd-call-to-action
      [title]="{ textKey: 'pageNotFound.title', tScope: 'uiComponents' }"
      [subtitle]="{ textKey: 'pageNotFound.subtitle', tScope: 'uiComponents' }"
      [actionButton]="actionButton"
      ><span class="bd-display-large">{{
        t('pageNotFound.code')
      }}</span></bd-call-to-action
    >
  </div>
</div>
